import Api from "@/services/Api.js";

const state = {

};

const getters = {

};

const actions = {
	CHANGE_PASSWORD({}, data) {
		return new Promise((resolve, reject) => {
			Api.post("change-password", data)
			.then(response => {
				resolve({'success': true});
			}).catch(error => {
				reject({'success': false, data: error.response.data});
			})
		});
	}
};

const mutations = {

};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};